import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import ResetInventory from 'components/Sales/Smart/Audit/ResetInventory';
import { getWarehouseCodeFromCache } from 'utils';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

export default function SmartMerge(): JSX.Element {
  return (
    <ContentLayout 
    titleKey="titles.resetInventory" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}
    // title={`Location Count(W#: ${getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))})`}
    >
      <ResetInventory />
    </ContentLayout>
  );
}
